import { createAction } from 'redux-act';

import { IRedirectOptions } from './redirect.types';

export const setRedirect = createAction<Partial<IRedirectOptions>>('RECIPIENT/REDIRECT');
